import { IApi } from 'utils/API';
import { IBinLocation, IItemBinLocation } from 'interfaces';
import { KeysOfType } from 'component_utils/typescriptUtils';
import { State } from '..';

interface EventProps {
  api: IApi;
}

interface Config<S, P, A, R> {
  nextState: number;
  binLocationKey: KeysOfType<S, IBinLocation>;
  binLocationContentsKey: KeysOfType<S, IItemBinLocation[]>;
}

const StateBinLocationContents = function <S, P extends EventProps, A extends {}, R>({
  nextState,
  binLocationKey,
  binLocationContentsKey,
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      const location = args.state[binLocationKey] as unknown as IBinLocation;
      const contents = await args.props.api.binLocation.getBinLocationContents(location.code);

      return {
        type: 'MOVE',
        data: {
          [binLocationContentsKey]: contents,
        } as any,
        nextState,
      };
    },
    attributes: {} as any,

    nodeName: 'T.states.binLocationContents',
    outputs: [
      {
        name: 'onFound',
        to: nextState,
      },
    ],
  };
};

export default StateBinLocationContents;
